import React from 'react';
import './SaleTicket.css';

const SaleTicket = ({ sale, onClose }) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const businessInfo = {
        name: user?.business_name || 'Comprobante de Venta',
        ruc: '10123456789',
        address: user?.address || 'Calle Las Flores 123',
        phone: user?.phone || '987 654 321',
        email: user?.email || ''
    };

    const handlePrint = () => {
        window.print();
    };

    return (
        <div className="ticket-overlay" onClick={onClose}>
            <div className="ticket-container" onClick={(e) => e.stopPropagation()}>
                <div className="ticket-content" id="ticket-print">
                    {/* Encabezado */}
                    <div className="ticket-header">
                        <h2>{businessInfo.name}</h2>
                    </div>

                    <div className="ticket-divider">================================</div>

                    {/* Información de la venta */}
                    <div className="ticket-sale-info">
                        <p><strong>TICKET DE VENTA #{sale.correlativo_local ? `VTA-${String(sale.correlativo_local).padStart(5, '0')}` : sale.id}</strong></p>
                        <p>Fecha: {new Date(sale.created_at || sale.sale_date).toLocaleString()}</p>
                        <p>Cliente: {sale.customer_name || 'Cliente General'}</p>
                        <p>Pago: {
                            sale.payment_method === 'efectivo' ? 'Efectivo' :
                            sale.payment_method === 'tarjeta' ? 'Tarjeta' :
                            sale.payment_method === 'transferencia' ? 'Transferencia' :
                            sale.payment_method === 'yape' ? 'Yape/Plin' :
                            sale.payment_method === 'fiado' ? 'Fiado (Por Cobrar)' :
                            (sale.payment_method || 'No especificado').toUpperCase()
                        }</p>
                        {sale.order_reference && <p>Pedido: {sale.order_reference}</p>}
                    </div>

                    <div className="ticket-divider">================================</div>

                    {/* Productos */}
                    <div className="ticket-items">
                        <table>
                            <thead>
                                <tr>
                                    <th>Producto</th>
                                    <th>Cant</th>
                                    <th>P.Unit</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sale.items && sale.items.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.product_name}</td>
                                        <td>{item.unit === 'kg' ? parseFloat(item.quantity) : parseInt(item.quantity)}</td>
                                        <td>S/. {parseFloat(item.unit_price).toFixed(2)}</td>
                                        <td>S/. {parseFloat(item.total_price).toFixed(2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="ticket-divider">================================</div>

                    {/* Totales */}
                    <div className="ticket-totals">
                        {sale.subtotal && sale.discount_amount > 0 && (
                            <>
                                <p>Subtotal: <span>S/. {parseFloat(sale.subtotal).toFixed(2)}</span></p>
                                <p>Descuento: <span>-S/. {parseFloat(sale.discount_amount).toFixed(2)}</span></p>
                            </>
                        )}
                        <p className="ticket-total">
                            <strong>TOTAL:</strong> 
                            <strong>S/. {parseFloat(sale.total || sale.total_amount).toFixed(2)}</strong>
                        </p>
                    </div>

                    <div className="ticket-divider">================================</div>

                    {/* Pie de página */}
                    <div className="ticket-footer">
                        <p>¡Gracias por su compra!</p>
                        <p>Vuelva pronto</p>
                    </div>
                </div>

                {/* Botones de acción */}
                <div className="ticket-actions no-print">
                    <button onClick={handlePrint} className="btn btn-primary">
                        🖨️ Imprimir
                    </button>
                    <button onClick={onClose} className="btn btn-secondary">
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SaleTicket;